import { combineReducers } from 'redux';
import dashboardMetrics from './dashboardMetrics.reducer';
import userPreferences from './userPreferences.reducer';

const reducer = combineReducers({
	dashboardMetrics,
	userPreferences,
});

export default reducer;
